import { FC, PropsWithChildren, useState } from 'react';
import { ModalContext } from './ModalContext';
import { ModalProps, ModalType, OpenedModal } from './types';

export const ModalProvider: FC<PropsWithChildren> = ({ children }) => {
  const [openedModals, setOpenedModals] = useState<OpenedModal[]>([]);

  const closeModal = (modalType: ModalType) => {
    setOpenedModals((previousModals) =>
      [...previousModals].filter((openedModal) => openedModal.modalType !== modalType),
    );
  };

  const openModal = (modalType: ModalType, modalProps?: ModalProps) => {
    if (!openedModals.find((modal) => modal.modalType === modalType))
      setOpenedModals((previousModals) => [...previousModals, { modalType, modalProps }]);
  };

  const contextState = {
    closeModal,
    openedModals,
    openModal,
  };

  return <ModalContext.Provider value={contextState}>{children}</ModalContext.Provider>;
};
